import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { INotification } from 'api/resources/notifications';
import { getNotifications } from 'api/resources/notifications';
import { ECacheKeys } from 'cache/CacheKeys';

export const useGetNotifications = (
	filter = '',
	options?: UseQueryOptions<INotification[]>
) => {
	return useQuery<INotification[], unknown>({
		queryKey: [ECacheKeys.Notifications, filter],
		queryFn: () => getNotifications(filter),
		refetchInterval: false,
		refetchOnWindowFocus: false,
		meta: {
			error: 'There was an error fetching the notifications, please try again',
		},
		...(options || {}),
	});
};
